import AnexoDropzone from './AnexoDropzone';
import AnexoUnico from './AnexoUnico';

export { AnexoDropzone, AnexoUnico };
